class CartDrawer extends Theme.Component {
  constructor() {
    super();
  }

  connectedCallback() {
    document.addEventListener("addtocart", (event) => {
      const giftError = event.detail?.subscriptionGiftError;

      this.render()
        .then(() => this.show())
        .then(() => {
          // Insert the alert only once the drawer is visible; live regions
          // inside visibility: hidden content aren't announced.
          if (giftError) this.showGiftErrorNotice(giftError);
        });
    });

    document.addEventListener("cartlink:click", (event) => {
      this.show();
    });

    if (Theme.URLParams.has("cart")) {
      this.show();
    }

    this.events();
  }

  showGiftErrorNotice(giftError) {
    const cartContent = this.querySelector("#cart") || this.querySelector(".cart-content");
    if (!cartContent) return;

    this.querySelector("[data-subscription-gift-error]")?.remove();

    const notice = document.createElement("div");
    notice.className = "cart-gift-error font-1 size--1";
    notice.setAttribute("data-subscription-gift-error", "");
    notice.setAttribute("role", "alert");
    notice.textContent = giftError?.message || Theme.Strings?.subscriptionGiftError || "";

    const header = cartContent.querySelector(".cart-header");
    if (header) {
      header.insertAdjacentElement("afterend", notice);
    } else {
      cartContent.prepend(notice);
    }
  }

  // Resolves once the drawer is visible, so callers can chain work that
  // needs it on screen (e.g. live-region announcements).
  show() {
    document.dispatchEvent(new CustomEvent("cartdrawer:show"));

    return new Promise((resolve) => {
      setTimeout(() => {
        this.classList.add("state--active");
        document.body.classList.add('no-scroll');
        resolve();
      }, 50);
    });
  }

  hide() {
    this.classList.remove("state--active");
    document.body.classList.remove('no-scroll');
  }

  changeSubscription(item, element) {

    this.change({
      id: item.key,
      quantity: item.quantity,
      selling_plan: element.value
    });
  }



  changeIntoSubscription(item, element) {

    element.classList.add("state--loading");

    const removePayload = {
      id: item.key,
      quantity: 0
    };

    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(removePayload)
    })
      .then(() => {
        const addPayload = {
          items: [
            {
              id: item.id,
              quantity: item.quantity,
              selling_plan: item.selling_plan
            }
          ]
        };

        return fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(addPayload)
        });
      })
      .then(() => {
        this.render().then(() => {
          element.classList.remove("state--loading");
        });
      });
  }

  change(data) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify(data)
    })
      .then((response) => response.json())
      .then((data) => {
        document.dispatchEvent(new CustomEvent("cart:change", {
          detail: data
        }));

        this.render();
      });
  }

  render() {
    const current_content = document.getElementById("cart");

    function get_new_content(response) {
      const string = JSON.parse(response)["cart-drawer"];
      const parser = new DOMParser();
      const doc = parser.parseFromString(string, "text/html");

      return doc.getElementById("cart");
    }

    return fetch("/?sections=cart-drawer")
      .then((response) => response.text())
      .then((response) => {
        current_content.replaceWith(get_new_content(response));
      })
      .then(() => {
        this.events();
      });
  }

  closeUpsellItem(detail, element) {
    console.log('[CartDrawer] closeUpsellItem triggered', { detail, element });
    const upsellItem = element.closest('.cart-upsell-item');
    if (upsellItem) {
      upsellItem.style.display = 'none';
      console.log('[CartDrawer] upsell item hidden');
    }
  }

  addUpsellItem(detail, element) {
  const variantId = element.dataset.variantId;
  if (!variantId) return;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(response => response.json())
    .then(response => {
      document.dispatchEvent(new CustomEvent('cartupsell', {
        detail: response
      }));

      this.render();
    });
}


  changeItemVariant(detail, element) {
    console.log('changeItemVariant triggered', { detail, element });

    console.log('[CIV] finding inputGroup from element:', element);
    const inputGroup = element.closest('.cart-item-variants-inputs');
    console.log('[CIV] inputGroup:', inputGroup);
    const allInputs = inputGroup.querySelectorAll('input[type="radio"]');
    console.log('[CIV] allInputs:', allInputs);
    const subscriptionButton = element.closest('.cart-item').querySelector('.cart-item-subscribe');
    const subscriptionSelect = element.closest('.cart-item').querySelector('.cart-item-select');
    console.log('[CIV] subscriptionButton:', subscriptionButton);
    console.log('[CIV] subscriptionSelect:', subscriptionSelect);

    allInputs.forEach(input => {
      console.log('[CIV] disabling input:', input);
      input.disabled = true;
      const label = input.nextElementSibling;
      if (label) {
        console.log('[CIV] disabling label for input:', input.id);
        label.classList.add('state--disabled');
      }
    });

    console.log('[CIV] disabling subscription UI');
    if (subscriptionButton) {
      subscriptionButton.classList.add('state--disabled');
    }

    if (subscriptionSelect) {
      subscriptionSelect.classList.add('state--disabled');
    }

    const label = document.querySelector(`label[for="${element.id}"] .spinner-container`);
    if (label) {
      label.classList.add('state--loading');
    }

    const data = detail;
    const removePayload = {
      id: data.key,
      quantity: data.quantity,
      selling_plan: null
    };
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(removePayload)
    })
      .then(() => {
        const addPayload = {
          items: [
            {
              id: data.id,
              quantity: 1
            }
          ]
        };
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(addPayload)
        });
      })
      .then(() => {
        this.render()
      });
  }
}

customElements.define("cart-drawer", CartDrawer);
